import { defineMessages } from 'react-intl';

export default defineMessages({
    routingNumber: {
        id: 'ml.common.agencysweep.Routing Number',
        defaultMessage: 'Routing Number'
    },
    accountNumber: {
        id: 'ml.common.agencysweep.Account Number',
        defaultMessage: 'Account Number'
    },
    customerPaymentMethod: {
        id: 'ml.common.agencysweep.Customer Payment Method',
        defaultMessage: 'Customer Payment Method'
    }
});